import AnalyticsIcon from "@mui/icons-material/Analytics";
import BadgeIcon from "@mui/icons-material/Badge";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ForumIcon from "@mui/icons-material/Forum";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import InsightsIcon from "@mui/icons-material/Insights";
import GavelIcon from "@mui/icons-material/Gavel";
import TuneIcon from "@mui/icons-material/Tune";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import CampaignIcon from "@mui/icons-material/Campaign";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import CoPresentIcon from "@mui/icons-material/CoPresent";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DifferenceIcon from "@mui/icons-material/Difference";
import SafetyDividerIcon from "@mui/icons-material/SafetyDivider";
import FeedIcon from "@mui/icons-material/Feed";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import SpeedIcon from '@mui/icons-material/Speed';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import VerifiedIcon from '@mui/icons-material/Verified';
import PlaceIcon from '@mui/icons-material/Place';
import SendIcon from '@mui/icons-material/Send';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentIcon from "@mui/icons-material/Assignment";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import { CalendarIcon } from "@mui/x-date-pickers";
import SchoolIcon from "@material-ui/icons/School";
import ChartSquareBarIcon from "../../icons/ChartSquareBar";
import UsersIcon from "../../icons/Users";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";


/**
 * Entrées retirées de la barre latérale.
 *
 * Les définitions restent en place plus bas : il suffit d'enlever un titre de
 * cette liste pour réafficher l'entrée. Une rubrique dont tous les items sont
 * masqués disparaît entièrement.
 */
const HIDDEN_SIDEBAR_TITLES = [
  "Groupements",
  "Satisfaction",
  "Performance",
  "Concepteur",
  "Salarié",
  "Services",
  "Présences",
  "Droits",
  "Multi-Établissements",
  "Notes de versions",
];

const withoutHiddenItems = (sections) =>
  sections
    .map((section) => ({
      ...section,
      items: Array.isArray(section.items)
        ? section.items.filter((item) => !HIDDEN_SIDEBAR_TITLES.includes(item.title))
        : section.items,
    }))
    .filter((section) => !Array.isArray(section.items) || section.items.length > 0);

const sections3Raw = [
    {
      title: "Général",
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
        {
          title: "Qualiopi",
          path: "/dashboard/qualiopi",
          icon: <VerifiedIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Campagne",
          path: "/dashboard/campaign",
          icon: <CampaignIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Lieux de formation",
          path: "/dashboard/lieux-formation",
          icon: <PlaceIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi des mails",
          path: "/dashboard/mails-tracking",
          icon: <MarkEmailReadIcon fontSize="small" />,
        },
        {
          title: "Suivi des inscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Suivi des reports et annulations",
          path: "/dashboard/reports-cancellations-tracking",
          icon: <EventBusyIcon fontSize="small" />,
        },
      ],
    },
  ];
  
const sections2Raw = [
    {
      title: "Général",
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
        {
          title: "Qualiopi",
          path: "/dashboard/qualiopi",
          icon: <VerifiedIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Campagne",
          path: "/dashboard/campaign",
          icon: <CampaignIcon fontSize="small" />,
        },
        {
          title: "Relance",
          path: "/dashboard/relaunch",
          icon: <ArrowCircleUpIcon fontSize="small" />,
        },
        // {
        //   title: "Qualité",
        //   path: "/dashboard/quality",
        //   icon: <CheckIcon fontSize="small" />,
        // },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Lieux de formation",
          path: "/dashboard/lieux-formation",
          icon: <PlaceIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi des mails",
          path: "/dashboard/mails-tracking",
          icon: <MarkEmailReadIcon fontSize="small" />,
        },
        {
          title: "Suivi des inscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Suivi des reports et annulations",
          path: "/dashboard/reports-cancellations-tracking",
          icon: <EventBusyIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Paramètres",
      items: [
        {
          title: "Notifications emails",
          path: "/dashboard/email-notifications",
          icon: <SendIcon fontSize="small" />,
        },
      ],
    },
  ];
  
const sectionsAdminRaw = [
    {
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
        {
          title: "Formation interne",
          path: "/dashboard/academie",
          icon: <SchoolIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Commercial",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Établissements",
          path: "/dashboard/etablissements",
          icon: <BusinessIcon fontSize="small" />,
        },
        {
          title: "Groupements",
          // path: '/dashboard/groupements',
          icon: <GroupsIcon fontSize="small" />,
        },
        {
          title: "Campagne",
          path: "/dashboard/campaign",
          icon: <CampaignIcon fontSize="small" />,
        },
        {
          title: 'Relance',
          path: '/dashboard/relaunch',
          icon: <ArrowCircleUpIcon fontSize="small" />
        }
      ]
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
        {
          title: "Qualiopi",
          path: "/dashboard/qualiopi",
          icon: <VerifiedIcon fontSize="small" />,
        },
        {
          title: "Satisfaction",
          path: "/dashboard/satisfactions",
          icon: <SentimentSatisfiedAltIcon fontSize="small" />,
        },
        {
          title: "Performance",
          path: "/dashboard/performances",
          icon: <SpeedIcon fontSize="small" />,
        },
        {
          title: "Questionnaire",
          path: "/dashboard/questionnaire-formation",
          icon: <DescriptionIcon fontSize="small" />,
        },
        {
          title: "Résultats des questionnaires",
          path: "/dashboard/questionnaire-satisfaction",
          icon: <FeedIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Partenaires",
          path: "/dashboard/partners",
          icon: <GroupWorkIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Lieux de formation",
          path: "/dashboard/lieux-formation",
          icon: <PlaceIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi des mails",
          path: "/dashboard/mails-tracking",
          icon: <MarkEmailReadIcon fontSize="small" />,
        },
        {
          title: "Suivi des inscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Suivi des reports et annulations",
          path: "/dashboard/reports-cancellations-tracking",
          icon: <EventBusyIcon fontSize="small" />,
        },
        {
          title: "Concepteur",
          path: "",
          icon: <PersonOutlineIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Rapport",
      items: [
        {
          title: "Analyse",
          path: "/dashboard/analysis",
          icon: <AnalyticsIcon />,
        },
        {
          title: "Rapports personnalisés",
          path: "custom-reports",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Suivi des apprenants",
          path: "/dashboard/shift",
          icon: <DifferenceIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Ressources humaines",
      items: [
        {
          title: "Tableau de bord RH",
          path: "/dashboard/rh",
          icon: <InsightsIcon fontSize="small" />,
        },
        {
          title: "Recrutement",
          path: "/dashboard/rh/recrutement",
          icon: <PersonSearchIcon fontSize="small" />,
        },
        {
          title: "Onboarding & offboarding",
          path: "/dashboard/rh/onboarding",
          icon: <FlightTakeoffIcon fontSize="small" />,
        },
        {
          title: "Collaborateurs",
          path: "/dashboard/rh/collaborateurs",
          icon: <BadgeIcon fontSize="small" />,
        },
        {
          title: "Congés & absences",
          path: "/dashboard/rh/conges",
          icon: <BeachAccessIcon fontSize="small" />,
        },
        {
          title: "Pointage",
          path: "/dashboard/rh/pointage",
          icon: <ScheduleIcon fontSize="small" />,
        },
        {
          title: "Entretiens",
          path: "/dashboard/rh/entretiens",
          icon: <ForumIcon fontSize="small" />,
        },
        {
          title: "Plan de formation",
          path: "/dashboard/rh/formation",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Santé au travail",
          path: "/dashboard/rh/sante",
          icon: <HealthAndSafetyIcon fontSize="small" />,
        },
        {
          title: "Handicap & inclusion",
          path: "/dashboard/rh/handicap",
          icon: <AccessibilityNewIcon fontSize="small" />,
        },
        {
          title: "Conformité France",
          path: "/dashboard/rh/conformite",
          icon: <GavelIcon fontSize="small" />,
        },
        {
          title: "Paramètres RH",
          path: "/dashboard/rh/parametres",
          icon: <TuneIcon fontSize="small" />,
        },
        {
          title: "DUERP",
          path: "/dashboard/rh/duerp",
          icon: <GppMaybeIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Paramètres",
      items: [
        {
          title: "Activités",
          path: "/dashboard/logs",
          icon: <FeedIcon fontSize="small" />,
        },
        {
          title: "Utilisateurs",
          path: "/dashboard/users",
          icon: <ManageAccountsIcon fontSize="small" />,
        },
        {
          title: "Notifications emails",
          path: "/dashboard/email-notifications",
          icon: <SendIcon fontSize="small" />,
        },
        {
          title: "Rôles & permissions",
          path: "/dashboard/roles",
          icon: <AdminPanelSettingsIcon fontSize="small" />,
        },
        {
          title: "Multi-Établissements",
          path: "",
          icon: <LocationCityIcon fontSize="small" />,
        },
        {
          title: "Notes de versions",
          path: "/dashboard/version-notes",
          icon: <DescriptionIcon fontSize="small" />,
        },
      ],
    },
  ];
  
const sections4Raw = [
    {
      title: "Général",
      items: [
        {
          title: "Tableau de bord",
          path: "/dashboard",
          icon: <ChartSquareBarIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Qualité",
      items: [
        {
          title: "Tickets d'incidents",
          path: "/dashboard/tickets",
          icon: <ConfirmationNumberIcon fontSize="small" />,
        },
        {
          title: "Réclamations",
          path: "/dashboard/complaint",
          icon: <PriorityHighIcon fontSize="small" />,
        },
        {
          title: "Qualiopi",
          path: "/dashboard/qualiopi",
          icon: <VerifiedIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Gestion",
      items: [
        {
          title: "Apprenants",
          path: "/dashboard/customers",
          icon: <UsersIcon fontSize="small" />,
        },
        {
          title: "Prospects",
          path: "/dashboard/prospects",
          icon: <SafetyDividerIcon fontSize="small" />,
        },
        {
          title: "Calendrier",
          path: "/dashboard/calendar",
          icon: <CalendarIcon fontSize="small" />,
        },
        {
          title: "Relance",
          path: "/dashboard/relaunch",
          icon: <ArrowCircleUpIcon fontSize="small" />,
        },
        // {
        //   title: "Qualité",
        //   path: "/dashboard/quality",
        //   icon: <CheckIcon fontSize="small" />,
        // },
      ],
    },
    {
      title: "Pédagogie",
      items: [
        {
          title: "Formations",
          path: "/dashboard/formations",
          icon: <SchoolIcon fontSize="small" />,
        },
        {
          title: "Sessions",
          path: "/dashboard/formationSession",
          icon: <FilterNoneIcon fontSize="small" />,
        },
        {
          title: "Intervenants",
          path: "/dashboard/intervenants",
          icon: <CoPresentIcon fontSize="small" />,
        },
        {
          title: "Lieux de formation",
          path: "/dashboard/lieux-formation",
          icon: <PlaceIcon fontSize="small" />,
        },
        {
          title: "Suivi des tâches",
          path: "/dashboard/tasks-tracking",
          icon: <AssignmentIcon fontSize="small" />,
        },
        {
          title: "Suivi des mails",
          path: "/dashboard/mails-tracking",
          icon: <MarkEmailReadIcon fontSize="small" />,
        },
        {
          title: "Suivi des inscrits",
          path: "/dashboard/learners-tracking",
          icon: <AppRegistrationIcon fontSize="small" />,
        },
        {
          title: "Suivi des reports et annulations",
          path: "/dashboard/reports-cancellations-tracking",
          icon: <EventBusyIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Rapport",
      items: [
        {
          title: "Analyse",
          path: "/dashboard/analysis",
          icon: <AnalyticsIcon />,
        },
        {
          title: "Suivi des apprenants",
          path: "/dashboard/shift",
          icon: <DifferenceIcon fontSize="small" />,
        },
      ],
    },
    {
      title: "Paramètres",
      items: [
        {
          title: "Notifications emails",
          path: "/dashboard/email-notifications",
          icon: <SendIcon fontSize="small" />,
        },
      ],
    },
  ];

export const sections2 = withoutHiddenItems(sections2Raw);
export const sections3 = withoutHiddenItems(sections3Raw);
export const sections4 = withoutHiddenItems(sections4Raw);
export const sectionsAdmin = withoutHiddenItems(sectionsAdminRaw);

/**
 * Permission « voir » de chaque entrée du menu, par chemin. Doit rester
 * aligné sur les `path` de php/App/Permission/PermissionCatalog.php.
 *
 * Avec les permissions actives, le menu est UNIQUE : c'est celui de
 * l'administrateur (le plus complet), filtré par ce que le rôle autorise.
 * Une entrée absente de cette table n'est montrée qu'au super-administrateur.
 */
export const PATH_PERMISSIONS = {
  "/dashboard": "dashboard.view",
  "/dashboard/academie": "academie.view",
  "/dashboard/rh": "rh_dashboard.view",
  "/dashboard/rh/conformite": "rh_conformite.view",
  "/dashboard/rh/parametres": "rh_parametres.view",
  "/dashboard/rh/recrutement": "rh_recrutement.view",
  "/dashboard/rh/onboarding": "rh_onboarding.view",
  "/dashboard/rh/collaborateurs": "rh.view",
  "/dashboard/rh/conges": "rh_conges.view",
  "/dashboard/rh/pointage": "rh_pointage.view",
  "/dashboard/rh/entretiens": "rh_entretiens.view",
  "/dashboard/rh/formation": "rh_formation.view",
  "/dashboard/rh/sante": "rh_sante.view",
  "/dashboard/rh/handicap": "rh_handicap.view",
  "/dashboard/rh/duerp": "rh_duerp.view",
  "/dashboard/customers": "customers.view",
  "/dashboard/prospects": "prospects.view",
  "/dashboard/calendar": "calendar.view",
  "/dashboard/etablissements": "etablissements.view",
  "/dashboard/campaign": "campaign.view",
  "/dashboard/relaunch": "relaunch.view",
  "/dashboard/tickets": "tickets.view",
  "/dashboard/complaint": "complaints.view",
  "/dashboard/qualiopi": "qualiopi.view",
  "/dashboard/questionnaire-formation": "questionnaires.view",
  "/dashboard/questionnaire-satisfaction": "questionnaire_results.view",
  "/dashboard/partners": "partners.view",
  "/dashboard/formations": "formations.view",
  "/dashboard/formationSession": "sessions.view",
  "/dashboard/intervenants": "intervenants.view",
  "/dashboard/lieux-formation": "lieux.view",
  "/dashboard/tasks-tracking": "tasks_tracking.view",
  "/dashboard/mails-tracking": "mails_tracking.view",
  "/dashboard/learners-tracking": "learners_tracking.view",
  "/dashboard/reports-cancellations-tracking": "reports_cancellations.view",
  "/dashboard/analysis": "analysis.view",
  "custom-reports": "custom_reports.view",
  "/dashboard/shift": "shift.view",
  "/dashboard/logs": "logs.view",
  "/dashboard/users": "users.view",
  "/dashboard/roles": "roles.view",
  "/dashboard/email-notifications": "email_notifications.view",
  // Pages retirées du menu : permissions « sur demande »
  "/dashboard/satisfactions": "satisfactions.view",
  "/dashboard/performances": "performances.view",
  "/dashboard/version-notes": "version_notes.view",
};

/**
 * Menu piloté par les rôles : celui de l'administrateur, où les pages retirées
 * du menu pour tous (Satisfaction, Performance, Notes de versions) restent
 * présentes — elles n'apparaissent qu'aux rôles qui ont leur permission
 * « sur demande ». Les autres titres masqués (sans page derrière) le restent.
 */
const OPTIN_TITLES = ["Satisfaction", "Performance", "Notes de versions"];

export const sectionsDynamic = sectionsAdminRaw
  .map((section) => ({
    ...section,
    items: Array.isArray(section.items)
      ? section.items.filter((item) => !HIDDEN_SIDEBAR_TITLES.includes(item.title) || OPTIN_TITLES.includes(item.title))
      : section.items,
  }))
  .filter((section) => !Array.isArray(section.items) || section.items.length > 0);
